import React from "react";

import MuiAccordionDetails from "@mui/material/AccordionDetails";
import styled from "@mui/material/styles/styled";
import Typography from "@mui/material/Typography";

import BaseAccordion, {
  AccordionProps as BaseAccordionProps,
  AccordionSummary as BaseAccordionSummary,
} from "@rui/Accordion";
import { Row } from "@rui/Stack";

type AccordionProps = BaseAccordionProps & {
  borderRadius?: React.CSSProperties["borderRadius"];
};

const Accordion = styled<React.FC<AccordionProps>>(
  ({ borderRadius: _br, ...props }) => <BaseAccordion {...props} />
)(({ borderRadius }) => ({
  "&:not(.Mui-expanded) .MuiAccordionSummary-root": {
    borderRadius: borderRadius ?? "4px",
  },
  "& .MuiAccordionSummary-root": {
    minHeight: 0,
    borderRadius: borderRadius,
  },
}));

const AccordionSummary = styled(BaseAccordionSummary)(({ theme }) => ({
  backgroundColor: theme.palette.transparent.black[4],
  flexDirection: "row-reverse",
  borderTopRightRadius: "4px",
  borderTopLeftRadius: "4px",
}));

const AccordionDetails = styled(MuiAccordionDetails)({
  padding: 0,
});

export interface CategoryAccordionProps {
  children: React.ReactNode;
  borderRadius?: React.CSSProperties["borderRadius"];
  endIcon?: React.ReactNode;
  label: string;
}

const CategoryAccordion = ({
  children,
  borderRadius,
  endIcon = null,
  label,
}: CategoryAccordionProps) => {
  return (
    <Accordion defaultExpanded borderRadius={borderRadius}>
      <AccordionSummary>
        <Row variant="apart" flex={1} marginLeft={1.5}>
          <Typography variant="bodyPrimaryMed" color="shades.neutral.800">
            {label}
          </Typography>
          {endIcon}
        </Row>
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
};

export default CategoryAccordion;
